<tt-page>
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-list [ttData]="plans"></tt-list>
    </tt-card>
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-button ttText="create_new_shiftplan" ttIcon="fas fa-plus" ttTextAlign="left" ttIconPullRight ttGoto="shiftplan" [ttGotoParms]="{ shiftplan_id: '' }"></tt-button>
    </tt-card>
</tt-page>
